// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateRevisionId } from './TestTemplateRevision';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { externalTestPartnerId } from './ExternalTestPartner';
import { z } from 'zod';
export const testSessionId = (z.number());
export const testSession = z.object({
    id: testSessionId,
    test_template_id: testTemplateRevisionId.nullable(),
    created_at: z.date(),
    operator_id: operatorId.nullable(),
    equipment_id: equipmentId.nullable(),
    notebook_md: z.string().nullable(),
    started_at: z.date().nullable(),
    completed_at: z.date().nullable(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    external_test_partner_id: externalTestPartnerId.nullable(),
    sent_at: z.date().nullable(),
    lab_order_reference: z.string().nullable(),
});
export const testSessionInitializer = z.object({
    id: testSessionId.optional(),
    test_template_id: testTemplateRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    notebook_md: z.string().optional().nullable(),
    started_at: z.date().optional().nullable(),
    completed_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    external_test_partner_id: externalTestPartnerId.optional().nullable(),
    sent_at: z.date().optional().nullable(),
    lab_order_reference: z.string().optional().nullable(),
});
export const testSessionMutator = z.object({
    id: testSessionId.optional(),
    test_template_id: testTemplateRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    notebook_md: z.string().optional().nullable(),
    started_at: z.date().optional().nullable(),
    completed_at: z.date().optional().nullable(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    external_test_partner_id: externalTestPartnerId.optional().nullable(),
    sent_at: z.date().optional().nullable(),
    lab_order_reference: z.string().optional().nullable(),
});
//# sourceMappingURL=TestSession.js.map